import React from 'react';
import './Homepage.css';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const BranchesSection = () => {
  return (
    <div className='container-fluid' id='branches-section'>
      <div className="row">
        <div className="col"><img src="img-data/homepage/location-map.png" alt=".." /></div>
        <div className="col">
            <div className='branches-heading'>
                Our Branches
            </div>
            <div className='para'>
                
"Our branches are hubs of innovation, fostering growth, sustainability, and connectivity. With excellence, diversity, and accessibility at our core, we strive for efficiency, empowerment, and community engagement."
            </div>
            <div className="locations">
            <div><LocationOnIcon/>Gurugram</div>
            <div><LocationOnIcon/>Delhi</div>
            <div><LocationOnIcon/>Noida</div>
            <div><LocationOnIcon/>Lucknow</div>
            <div><LocationOnIcon/>Varanasi</div>
            <div><LocationOnIcon/>Bahraich</div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default BranchesSection
